/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BedNoteCreatedByUser
 */
export interface BedNoteCreatedByUser {
    /**
     * 
     */
    id?: string;
    /**
     * 
     */
    first_name?: string;
    /**
     * 
     */
    last_name?: string;
}

/**
 * Check if a given object implements the BedNoteCreatedByUser interface.
 */
export function instanceOfBedNoteCreatedByUser(value: object): value is BedNoteCreatedByUser {
    return true;
}

export function BedNoteCreatedByUserFromJSON(json: any): BedNoteCreatedByUser {
    return BedNoteCreatedByUserFromJSONTyped(json, false);
}

export function BedNoteCreatedByUserFromJSONTyped(json: any, ignoreDiscriminator: boolean): BedNoteCreatedByUser {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'first_name': json['first_name'] == null ? undefined : json['first_name'],
        'last_name': json['last_name'] == null ? undefined : json['last_name'],
    };
}

export function BedNoteCreatedByUserToJSON(json: any): BedNoteCreatedByUser {
    return BedNoteCreatedByUserToJSONTyped(json, false);
}

export function BedNoteCreatedByUserToJSONTyped(value?: BedNoteCreatedByUser | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'first_name': value['first_name'],
        'last_name': value['last_name'],
    };
}

